import React, { useEffect, useState, Fragment } from 'react';
import { useUser } from '../UserContext';
import { useNavigate, Link } from 'react-router-dom';
import './index.css';
import logo from '../../imagens/TSTRIPAS.png';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';

const Cliente = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();

  const [loadingClientes, setLoadingClientes] = useState(true);
  const [clientes, setClientes] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showModalCadastroCliente, setShowModalCadastroCliente] = useState(false);

  const [showFinanceiroModal, setShowFinanceiroModal] = useState(false);
  const [showPedidoModal, setShowPedidoModal] = useState(false);
  const [expandedClienteId, setExpandedClienteId] = useState(null);
  const [financeiroData, setFinanceiroData] = useState([]);
  const [loadingFinanceiro, setLoadingFinanceiro] = useState(false);
  const [pedidoData, setPedidoData] = useState([]);
  const [loadingPedido, setLoadingPedido] = useState(false);

  // Itens do pedido
  const [itensPedido, setItensPedido] = useState([]);
  const [nfeSelecionada, setNfeSelecionada] = useState(null);
  const [loadingItens, setLoadingItens] = useState(false);

  //envio de documentos
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [message, setMessage] = useState('');

  const [inputKey, setInputKey] = useState(0);

  const [etapa, setEtapa] = useState(null); // null | 'salvando' | 'cadastrado' | 'enviando' | 'concluido' | 'erro'
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  useEffect(() => {
    if (!userInfo?.username || !userInfo?.company) {
      localStorage.removeItem('userInfo');
      navigate('/home');
    }
  }, [userInfo, navigate]);

  const credentials = btoa(`${userInfo.alias};${userInfo.venLogin}:${userInfo.venSenha}`);

  const atualizaClientes = async () => {
    try {
      setLoadingClientes(true);

      const res = await fetch(`${userInfo.url}/cliente/WenAPP/vendedor/${userInfo.ven_id}`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        }
      });

      const text = await res.text();
      const safeText = text.replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);
      setClientes(json);
    } catch (err) {
      console.error('Erro ao buscar clientes:', err);
    } finally {
      setLoadingClientes(false);
    }
  };

  useEffect(() => {
    const fetchClientes = async () => {
      try {
        setLoadingClientes(true);

        const res = await fetch(`${userInfo.url}/cliente/WenAPP/vendedor/${userInfo.ven_id}`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          }
        });

        const text = await res.text();
        const safeText = text.replace(/\u00A0/g, ' ').trim();
        const json = JSON.parse(safeText);
        setClientes(json);
      } catch (err) {
        //console.error('Erro ao buscar clientes:', err);
      } finally {
        setLoadingClientes(false);
      }
    };

    fetchClientes();
  }, [userInfo, credentials]);

  const filteredClientes = clientes.filter((c) => {
    const termo = searchTerm.toLowerCase();

    return (
      c.cliId?.toString().includes(termo) ||
      c.colNome?.toLowerCase().includes(termo) ||
      c.colFantasia?.toLowerCase().includes(termo) ||
      c.colCnpjCpf?.toLowerCase().includes(termo)
    );
  });

  const handleSelectCliente = (cliente) => {
    setSelectedCliente(cliente);
    setSearchTerm(cliente.colNome);
    setShowSuggestions(false);
  };

  const openModalCadastroCliente = () => {
    setShowModalCadastroCliente(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const formData = {
      COL_NOME: form.COL_NOME?.value.toUpperCase() || '',
      COL_FANTASIA: form.COL_FANTASIA?.value.toUpperCase() || '',
      COL_TIPO_PESSOA: form.COL_TIPO_PESSOA?.value || '',
      COL_CNPJ_CPF: form.COL_CNPJ_CPF?.value || '',
      COL_INSCRICAO_ESTADUAL: form.COL_INSCRICAO_ESTADUAL?.value || '',
      END_RUA: form.END_RUA?.value.toUpperCase() || '',
      END_NUMERO: form.END_NUMERO?.value || '',
      COL_CONTATO: form.COL_CONTATO?.value.toUpperCase() || '',
      COL_FONE1: form.COL_FONE1?.value || '',
      COL_FONE2: form.COL_FONE2?.value || '',
      COL_EMAIL: form.COL_EMAIL?.value || '',
      COL_CELULAR_WHATSAPP: form.COL_CELULAR_WHATSAPP?.value || '',
      END_CEP: form.END_CEP?.value || '',
      END_COMPLEMENTO: form.END_COMPLEMENTO?.value.toUpperCase() || '',
      END_BAIRRO: form.END_BAIRRO?.value.toUpperCase() || '',
      END_CIDADE: form.END_CIDADE?.value.toUpperCase() || '',
      END_ESTADO: form.END_ESTADO?.value || '',
      CLI_TIPO: form.CLI_TIPO?.value || '',
      VEN_ID: userInfo.ven_id || '',
      COL_OBSERVACAO: form.COL_OBSERVACAO?.value || '',
      COL_ATIVO: userInfo.bloqClienteInconpleto === 'T' ? true : false,
    };

    if (userInfo.bloqClienteInconpleto === 'T') {
      if (!formData.COL_NOME) return alert('O campo NOME é obrigatório.');
      if (!formData.COL_FANTASIA) return alert('O campo FANTASIA é obrigatório.');
      if (!formData.COL_TIPO_PESSOA) return alert('O campo TIPO PESSOA é obrigatório.');
      if (!formData.COL_CNPJ_CPF) return alert('O campo CNPJ/CPF é obrigatório.');
      if (!formData.END_RUA) return alert('O campo RUA é obrigatório.');
      if (!formData.END_NUMERO) return alert('O campo NÚMERO é obrigatório.');
      if (!formData.COL_CONTATO) return alert('O campo CONTATO é obrigatório.');
      if (!formData.COL_FONE1) return alert('O campo FONE 1 é obrigatório.');
      if (!formData.COL_EMAIL) return alert('O campo EMAIL é obrigatório.');
      if (!formData.COL_CELULAR_WHATSAPP) return alert('O campo CELULAR/WHATSAPP é obrigatório.');
      if (!formData.END_CEP) return alert('O campo CEP é obrigatório.');
      if (!formData.END_BAIRRO) return alert('O campo BAIRRO é obrigatório.');
      if (!formData.END_CIDADE) return alert('O campo CIDADE é obrigatório.');
      if (!formData.END_ESTADO) return alert('O campo ESTADO é obrigatório.');
    }

    try {
      setEtapa('salvando');

      const response = await fetch(`${userInfo.url}/cliente`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        setEtapa('erro');
        await sleep(2000);
        setEtapa(null);
        return;
      }

      // Retorno da API: { "cli_id": 4489 }
      const textRetorno = await response.text();
      const retorno = JSON.parse(textRetorno.replace(/\u00A0/g, ' ').trim());
      const novoCliId = retorno?.col_id;

      setEtapa('cadastrado');   // animação "Cliente cadastrado"
      await sleep(1500);

      if (files.length) {
        if (!novoCliId) {
          alert('Cliente cadastrado, mas não foi possível obter o código do cliente para anexar os arquivos.');
        } else {
          setEtapa('enviando');   // loading "Enviando arquivos"
          const ok = await envioArquivo(novoCliId);
          if (!ok) {
            alert('Cliente cadastrado, mas alguns arquivos falharam. Reenvie pelo cadastro do cliente.');
          }
        }
      }

      setEtapa('concluido');
      await sleep(1500);

      setEtapa(null);
      setShowModalCadastroCliente(false);
      atualizaClientes();
    } catch (error) {
      console.error('Erro ao salvar cliente:', error);
      setEtapa('erro');
      await sleep(2000);
      setEtapa(null);
    } 
  };

  const openFinanceiroModal = async (cliente) => {
    setSelectedCliente(cliente);
    setShowFinanceiroModal(true);
    setFinanceiroData([]);
    setLoadingFinanceiro(true);

    try {
      const res = await fetch(`${userInfo.url}/receber/cliente/${cliente.cliId}`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        }
      });

      const text = await res.text();
      const safeText = text.replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);

      setFinanceiroData(json);
    } catch (err) {
      console.error('Erro ao buscar dados financeiros:', err);
    } finally {
      setLoadingFinanceiro(false);
    }
  };

  const openPedidoModal = async (cliente) => {
    setSelectedCliente(cliente);
    setShowPedidoModal(true);
    setPedidoData([]);
    setLoadingPedido(true);

    // Limpa os itens ao abrir
    setItensPedido([]);
    setNfeSelecionada(null);

    try {
      const res = await fetch(`${userInfo.url}/nfe`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
          'venId': userInfo.ven_id,
          'cliId': cliente.cliId,
        }
      });

      const text = await res.text();
      const safeText = text.replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);

      setPedidoData(json);
    } catch (err) {
      console.error('Erro ao buscar dados do pedido:', err);
    } finally {
      setLoadingPedido(false);
    }
  };

  // Função renomeada para não conflitar com o estado "itensPedido"
  const buscarItensPedido = async (nfeId) => {
    // Se já está aberto, fecha
    if (nfeSelecionada === nfeId) {
      setNfeSelecionada(null);
      setItensPedido([]);
      return;
    }

    setNfeSelecionada(nfeId);
    setItensPedido([]);
    setLoadingItens(true);

    try {
      const res = await fetch(`${userInfo.url}/itemnfe/pedido/${nfeId}`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        }
      });

      const text = await res.text();
      const safeText = text.replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);

      setItensPedido(json);
    } catch (err) {
      console.error('Erro ao buscar itens do Pedido:', err);
    } finally {
      setLoadingItens(false);
    }
  };

  const closeModals = () => {
    setShowFinanceiroModal(false);
    setShowPedidoModal(false);
    setSelectedCliente(null);
    setShowModalCadastroCliente(false);
    setFinanceiroData([]);
    setPedidoData([]);
    setItensPedido([]);
    setNfeSelecionada(null);
    setFiles([]);
    setPreviews([]);
  };

  const toggleExpand = (id) => {
    setExpandedClienteId(prevId => (prevId === id ? null : id));
  };

  const formatarData = (dataISO) => {
    if (!dataISO) return '';
    const d = new Date(dataISO);
    return d.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  };

  const imprimirBoleto = async (creId, cliente) => {
    try {
      await fetch(`${userInfo.url}/receber/boleto/impressao/${creId}`, {
        method: "GET",
        headers: { empresa: userInfo.alias },
      });

      const pdfUrl = `${userInfo.url}/pdf/${cliente.cliId}.pdf`;

      const response = await fetch(pdfUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      const agora = new Date();
      const dataHora = `${agora.getDate().toString().padStart(2, '0')}-${(agora.getMonth() + 1).toString().padStart(2, '0')}-${agora.getFullYear()}-${agora.getHours().toString().padStart(2, '0')}-${agora.getMinutes().toString().padStart(2, '0')}`;
      a.download = `Boleto-${cliente.colFantasia}-${dataHora}.pdf`;
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      alert("Erro ao imprimir boleto");
    }
  };

  const totalFinanceiro = financeiroData.reduce((acc, item) => acc + item.creVlrReceber, 0);

  const gerarPDFFinanceiro = () => {
    const pdf = new jsPDF();
    pdf.text(`Relatório Financeiro de Clientes Em Aberto`, 50, 10);
    pdf.text(`Cliente: ${selectedCliente?.colNome || 'Cliente'}`, 50, 20);

    const tableColumn = ["Cliente", "Pedido", "Título", "Parcela", "Pagamento", "Emissão", "Vencimento", "Valor"];
    const tableRows = financeiroData.map(item => [
      selectedCliente?.colNome || item.cliente,
      item.nfePedido,
      item.creTitulo,
      item.creParcela,
      item.crePagamento,
      formatarData(item.creDtaEmissao),
      formatarData(item.creDtaVencimento),
      `R$ ${item.creVlrReceber.toFixed(2)}`,
    ]);

    autoTable(pdf, {
      head: [tableColumn],
      body: tableRows,
      startY: 25,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [41, 128, 185] },
      theme: 'grid',
    });

    const totalPages = pdf.internal.getNumberOfPages();
    pdf.setPage(totalPages);
    const finalY = pdf.lastAutoTable.finalY || 30;
    const pageWidth = pdf.internal.pageSize.getWidth();
    const totalText = `Total: ${(totalFinanceiro ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL", })}`;
    const textWidth = pdf.getTextWidth(totalText);
    const xPos = pageWidth - textWidth - 14;
    const yPos = finalY + 10;

    pdf.text(totalText, xPos, yPos);
    pdf.save(`Relatório-Financeiro-${selectedCliente?.colNome || 'Cliente'}.pdf`);
  };

  const consultarCNPJ = async (cnpj) => {
    const cnpjLimpo = cnpj.replace(/\D/g, '');
    if (cnpjLimpo.length !== 14) {
      alert("CNPJ inválido para consulta.");
      return;
    }

    try {
      const response = await fetch(`https://publica.cnpj.ws/cnpj/${cnpjLimpo}`);
      const data = await response.json();

      if (data.estabelecimento) {
        const form = document.querySelector('form');
        form.COL_NOME.value = data.razao_social;
        form.COL_FANTASIA.value = data.estabelecimento.nome_fantasia || data.razao_social;
        form.END_RUA.value = data.estabelecimento.logradouro;
        form.END_NUMERO.value = data.estabelecimento.numero;
        form.END_CEP.value = data.estabelecimento.cep;
        form.END_BAIRRO.value = data.estabelecimento.bairro;
        form.END_CIDADE.value = data.estabelecimento.cidade.nome;
        form.END_ESTADO.value = data.estabelecimento.estado.sigla;
      }
    } catch (error) {
      alert("Erro ao consultar CNPJ. Verifique a conexão ou o limite de buscas.");
    }
  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    if (selectedFiles.length === 0) return;

    setFiles(selectedFiles);

    const newPreviews = selectedFiles.map((f) =>
      f.type.startsWith('image/') ? URL.createObjectURL(f) : null
    );
    setPreviews(newPreviews);
  };

  const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(',')[1]); // remove "data:...;base64,"
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

  const limparArquivos = () => {
    previews.forEach((p) => p && URL.revokeObjectURL(p));
    setFiles([]);
    setPreviews([]);
    setMessage('');
    setInputKey((k) => k + 1); // recria o input
  };

  const comprimirImagem = (file, maxLado = 1600, qualidade = 0.7) =>
    new Promise((resolve) => {
      if (!file.type.startsWith('image/')) return resolve(file);
      const img = new Image();
      img.onload = () => {
        const escala = Math.min(1, maxLado / Math.max(img.width, img.height));
        const canvas = document.createElement('canvas');
        canvas.width = img.width * escala;
        canvas.height = img.height * escala;
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(img.src);
        canvas.toBlob(
          (b) => resolve(new File([b], file.name.replace(/\.\w+$/, '.jpg'), { type: 'image/jpeg' })),
          'image/jpeg',
          qualidade
        );
      };
      img.onerror = () => resolve(file);
      img.src = URL.createObjectURL(file);
    });

  const envioArquivo = async (cliId) => {
    if (!files.length) return true;

    let sucesso = 0;
    let falha = 0;

    for (let i = 0; i < files.length; i++) {
      setMessage(`Enviando ${i + 1} de ${files.length}...`);
      try {
        const arquivo = await comprimirImagem(files[i]);
        const body = [
          {
            DOC_DESCRICAO: arquivo.name,
            COL_ID: String(cliId),          
            nome_arquivo: arquivo.name,
            base64: await fileToBase64(arquivo)
          }
        ];

        const response = await fetch(`${userInfo.url}/documentos/upload`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          },
          body: JSON.stringify(body),
        });

        if (response.ok) sucesso++;
        else {
          console.error('Erro no upload:', response.status, await response.text());
          falha++;
        }
      } catch (error) {
        console.error('Erro na requisição:', error);
        falha++;
      }
    }

    if (falha === 0) {
      limparArquivos();
      setMessage(`✅ ${sucesso} arquivo(s) enviado(s) com sucesso!`);
    } else {
      setMessage(`⚠️ ${sucesso} enviado(s), ${falha} falharam.`);
    }
    return falha === 0;
  };

  return (
    <>
      {loadingClientes ? (
        <div className="loading-container" tabIndex={-1}>
          <img src={logo} alt="Logo" className="loading-logo" />
          <p>Carregando clientes...</p>
        </div>
      ) : (
        <>
          <header className="header">
            <img src={logo} alt="Logo" className="header-logo" />
            <h2>Bem-vindo, {userInfo.username}!</h2>
            <h1>Cadastro de Clientes {userInfo.company}</h1>
          </header>

          <div className="top-bar">
            <Link to="/menu" className="link-style">Voltar ao menu</Link>
            <button className='cadastrarCliente' onClick={openModalCadastroCliente}>+</button>
          </div>

          <div className="cliente-box">
            <input
              type="text"
              placeholder="Pesquisar cliente..."
              value={searchTerm}
              autoFocus={!loadingClientes}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setShowSuggestions(true);
                setSelectedCliente(null);
              }}
              onFocus={() => setShowSuggestions(true)}
            />

            {searchTerm && (
              <button
                className="btn-limpar"
                onClick={() => {
                  setSearchTerm('');
                  setSelectedCliente(null);
                  setShowSuggestions(false);
                }}
              >
                Limpar
              </button>
            )}

            {showSuggestions && searchTerm && (
              <ul className="cliente-list">
                {filteredClientes.length > 0 ? (
                  filteredClientes.map((c, index) => (
                    <li key={`${c.cliId}-${index}`} onClick={() => handleSelectCliente(c)}>
                      <strong>{c.cliId}</strong> - {c.colNome}
                    </li>
                  ))
                ) : (
                  <li>❌ Nenhum cliente encontrado</li>
                )}
              </ul>
            )}
          </div>

          <div className="legenda">
            <span><strong>Legenda: </strong></span>
            <span><i className="fas fa-exclamation-triangle" style={{ color: '#e74343' }}></i> Cliente com pendências financeiras em Vermelho!</span>
          </div>

          <div className="clientes-container">
            {filteredClientes.map((cliente) => {
              const isExpanded = expandedClienteId === cliente.cliId;

              return (
                <div key={cliente.cliId} className="cliente-card">
                  <div className={cliente.vencido === "T" ? "cabClienteVencido" : "cabCliente"}>
                    <span><strong>ID:</strong> {cliente.cliId}</span>
                    <span><strong>Cliente:</strong> {cliente.colNome}</span>
                    <span><strong>Fantasia:</strong> {cliente.colFantasia}</span>
                    <button
                      className="expand-button"
                      onClick={() => toggleExpand(cliente.cliId)}
                    >
                      {isExpanded ? '−' : '+'}
                    </button>
                  </div>

                  {isExpanded && (
                    <>
                      <span><strong>CNPJ/CPF:</strong> {cliente.colCnpjCpf}</span>
                      <span><strong>Inscrição Estadual:</strong> {cliente.colInscricaoEstadual}</span>
                      <span><strong>Endereço:</strong> {cliente.endRua}, {cliente.endNumero}</span>
                      <span><strong>Complemento:</strong> {cliente.endComplemento}</span>
                      <span><strong>Cidade:</strong> {cliente.endCidade}</span>
                      <span><strong>UF:</strong> {cliente.endEstado}</span>
                      <span><strong>CEP:</strong> {cliente.endCep}</span>
                      <span><strong>Email:</strong> {cliente.colEmail}</span>
                      <span><strong>Contato:</strong> {cliente.colContato}</span>
                      <span><strong>Fone1:</strong> {cliente.colFone1}</span>
                      <span><strong>Fone2:</strong> {cliente.colFone2}</span>
                      <span className="whats-line">
                        <strong>Whats:</strong> {cliente.colCelularWhatsapp}
                        {cliente.colCelularWhatsapp && (
                          <button
                            className="whats"
                            onClick={() => {
                              const celular = cliente.colCelularWhatsapp?.replace(/\D/g, '');
                              if (celular) {
                                const url = `https://wa.me/55${celular}`;
                                window.open(url, '_blank');
                              }
                            }}
                          >
                            <i className="fab fa-whatsapp"></i>
                          </button>
                        )}
                      </span>
                      <span><strong>Forma de Pagamento:</strong> {cliente.pagDescricao}</span>
                      <span><strong>Prazo de Pagamento:</strong> {cliente.prazo}</span>
                      <span><strong>Limite de Crédito:</strong> R$ {(cliente.cliLimiteCredito).toFixed(2)}<strong> - Limite Disponível: R$ {(cliente.limiteDisponivel).toFixed(2)}</strong></span>

                      <div className="card-buttons">
                        <button onClick={() => openFinanceiroModal(cliente)}>📊 Financeiro</button>
                        <button onClick={() => openPedidoModal(cliente)}>🧾 Pedidos</button>
                        <button
                          onClick={() => {
                            const destino = encodeURIComponent(
                              `${cliente.endRua || ''}, ${cliente.endNumero || ''} - ${cliente.endCidade || ''}${cliente.endEstado || ''}`
                            );
                            window.open(`https://www.google.com/maps/dir/?api=1&destination=${destino}`, '_blank');
                          }}
                        >
                          📍 Rota
                        </button>
                      </div>
                      <div style={{ marginBottom: '15px', padding: '10px', border: '1px solid #eee', borderRadius: '8px' }}>
                        <label htmlFor="file-upload" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                          Selecione o arquivo ou tire a foto para este pedido:
                        </label>
                        <input
                          key={inputKey}
                          id="file-upload"
                          type="file"
                          multiple
                          accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          onChange={handleFileChange}
                        />

                        {message && <p style={{ fontSize: '13px', color: '#007bff', marginTop: '5px' }}>{message}</p>}

                        {files.length > 0 && (
                          <div style={{ marginTop: '15px' }}>
                            <p style={{ fontSize: '14px', margin: '5px 0' }}>Arquivos selecionados ({files.length}):</p>
                            {files.map((f, idx) => (
                              <div key={idx} style={{ marginBottom: '8px' }}>
                                {previews[idx] ? (
                                  <img
                                    src={previews[idx]}
                                    alt={`Preview ${idx}`}
                                    style={{ width: '100%', maxHeight: '150px', objectFit: 'contain', borderRadius: '8px' }}
                                  />
                                ) : (
                                  <p style={{ fontSize: '14px', color: '#555' }}>📄 {f.name}</p>
                                )}
                              </div>
                            ))}
                            <div className='btnEnviarArquivo'>
                              <button type="button" className="limparArquivos" onClick={limparArquivos}>Limpar Arquivos</button>
                              <button type="submit" className="salvarArquivos" onClick={() => envioArquivo(cliente.colId)} disabled={!!etapa}>Salvar</button>
                            </div>
                          </div>
                        )}
                      </div> 
                    
                    </>
                  )}
                </div>
              );
            })}
          </div>

          {showFinanceiroModal && (
            <div className="modal-cliente">
              <div className="modal-content-cliente">
                <h2>Financeiro - {selectedCliente.colNome}</h2>

                {loadingFinanceiro && <p>Carregando...</p>}

                {!loadingFinanceiro && financeiroData.length > 0 ? (
                  <div>
                    <table className="financeiro-grid">
                      <thead>
                        <tr>
                          <th>Pedido</th>
                          <th>Título</th>
                          <th>Parcela</th>
                          <th>Pagamento</th>
                          <th>Emissão</th>
                          <th>Vencimento</th>
                          <th>Status</th>
                          <th>Valor</th>
                          <th>Boleto</th>
                          <th>Banco</th>
                          <th>🖨️ Boleto</th>
                        </tr>
                      </thead>
                      <tbody>
                        {financeiroData.map((item, idx) => (
                          <tr key={idx}>
                            <td>{item.nfePedido}</td>
                            <td>{item.creTitulo}</td>
                            <td>{item.creParcela}</td>
                            <td>{item.crePagamento}</td>
                            <td>{formatarData(item.creDtaEmissao)}</td>
                            <td>{formatarData(item.creDtaVencimento)}</td>
                            <td>{item.creStatus}</td>
                            <td>R$ {item.creVlrReceber.toFixed(2)}</td>
                            <td>{item.creNumBoleto}</td>
                            <td>{item.banNome}</td>
                            <td>{item.crePagamento === 'BOLETO' && (<button className='impBoleto' onClick={() => imprimirBoleto(item.creId, selectedCliente)}>🧾</button>)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    <span className='total-financeiro'>Total: <strong>R$ {financeiroData.reduce((acc, item) => acc + item.creVlrReceber, 0).toFixed(2)}</strong></span>
                  </div>
                ) : !loadingFinanceiro && (
                  <p>❌ Nenhum registro encontrado</p>
                )}

                <button onClick={closeModals}>Fechar</button>
                <button className='btnPDF' onClick={gerarPDFFinanceiro}>🖨️ PDF</button>
              </div>
            </div>
          )}

          {showPedidoModal && (
            <div className="modal-cliente">
              <div className="modal-content-cliente">
                <h2>Pedidos - {selectedCliente.colNome}</h2>
                {loadingPedido && <p>Carregando...</p>}

                {!loadingPedido && pedidoData.length > 0 ? (
                  <>
                    <table className="Pedido-grid">
                      <thead>
                        <tr>
                          <th>Pedido</th>
                          <th>Nota</th>
                          <th>Cadastro</th>
                          <th>Emissão</th>
                          <th>Status</th>
                          <th>Total Produtos</th>
                          <th>Total Nota</th>
                          <th>🖨️ Romaneio</th>
                          <th>Itens</th>
                        </tr>
                      </thead>
                        <tbody>
                          {pedidoData.map((item, idx) => (
                            <Fragment key={idx}>
                              {/* Linha principal do pedido */}
                              <tr className={nfeSelecionada === item.nfeId ? 'linha-ativa' : ''}>
                                <td>{item.nfeId}</td>
                                <td>{item.nfeNota}</td>
                                <td>{formatarData(item.nfeDtaCadastro) || ''}</td>
                                <td>{formatarData(item.nfeDtaEmissao) || ''}</td>
                                <td>{item.nfeStatus}</td>
                                <td>{item.nfeTotMercadoria.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</td>
                                <td>{item.nfeTotNota.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</td>
                                <td><button className='btn-romaneio' title="Imprimir romaneio">🧾</button></td>
                                <td>
                                  <button
                                    className='btn-itens'
                                    title={nfeSelecionada === item.nfeId ? "Fechar itens" : "Ver itens do pedido"}
                                    onClick={() => buscarItensPedido(item.nfeId)}
                                  >
                                    {nfeSelecionada === item.nfeId ? '−' : "+" }
                                  </button>
                                </td>
                              </tr>

                              {/* Linha expandida com os itens, logo abaixo da linha clicada */}
                              {nfeSelecionada === item.nfeId && (
                                <tr className="linha-itens">
                                  <td colSpan={9}>
                                    {loadingItens ? (
                                      <p className="carregando-itens">Carregando itens...</p>
                                    ) : itensPedido.length > 0 ? (
                                      <table className="itens-grid">
                                        <thead>
                                          <tr>
                                            <th>Código</th>
                                            <th>Descrição</th>
                                            <th>Qtde</th>
                                            <th>Vlr. Unit.</th>
                                            <th>Vlr. Total</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {itensPedido.map((item, i) => (
                                            <tr key={i}>
                                              <td>{item.proCodInterno ?? ''}</td>
                                              <td>{item.proDescricao ?? ''}</td>
                                              <td>{item.infeQtdProduto}</td>
                                              <td>{Number(item.infeVlrProduto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                              <td>{(Number(item.infeQtdProduto) * Number(item.infeVlrProduto)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    ) : (
                                      <p className="sem-itens">❌ Nenhum item encontrado</p>
                                    )}
                                  </td>
                                </tr>
                              )}
                            </Fragment>
                          ))}
                        </tbody>

                    </table>
                  </>
                ) : !loadingPedido && (
                  <p>❌ Nenhum registro encontrado</p>
                )}
                <button onClick={closeModals}>Fechar</button>
              </div>
            </div>
          )}

          {userInfo.cadastrarCliente === 'T' && showModalCadastroCliente && (
            <div className="modal-cliente">
              <div className="modal-content-cliente">
                <h2>Cadastro de Clientes</h2>
                <form
                  onSubmit={handleSubmit}
                  style={{ maxHeight: '70vh', overflowY: 'auto' }}
                >
                  <div className="form-grid">
                    <select name='COL_TIPO_PESSOA' placeholder='Tipo Pessoa'>
                      <option value='FÍSICA'>Física</option>
                      <option value='JURÍDICA'>Jurídica</option>
                    </select>

                    <div style={{ display: 'flex', gap: '5px' }} className='cnpj-cpf-container'>
                      <input name="COL_CNPJ_CPF" placeholder="CNPJ/CPF" id="doc_cliente" />
                      <button
                        type="button"
                        className='btnConsultaCNPJ'
                        onClick={() => {
                          const doc = document.getElementsByName('COL_CNPJ_CPF')[0].value;
                          if (doc.replace(/\D/g, '').length === 14) {
                            consultarCNPJ(doc);
                          } else {
                            alert("A consulta automática gratuita só está disponível para CNPJ.");
                          }
                        }}
                      >
                        🔍
                      </button>
                    </div>

                    <input name="COL_NOME" placeholder="Nome" required
                      style={{ textTransform: 'uppercase' }}
                      onBlur={e => e.target.value = e.target.value.toUpperCase()}
                    />

                    <input name="COL_FANTASIA" placeholder="Fantasia" required
                      style={{ textTransform: 'uppercase' }}
                      onBlur={e => e.target.value = e.target.value.toUpperCase()}
                    />

                    <input name="COL_INSCRICAO_ESTADUAL" placeholder="Inscrição Estadual" />

                    <input name="COL_CONTATO" placeholder="Contato"
                      style={{ textTransform: 'uppercase' }}
                      onBlur={e => e.target.value = e.target.value.toUpperCase()} />

                    <input name="COL_FONE1" placeholder="Fone 1" type='phone' />

                    <input name="COL_FONE2" placeholder="Fone 2" type='phone' />

                    <input name="COL_EMAIL" placeholder="Email" type='email' />

                    <input name="COL_CELULAR_WHATSAPP" placeholder="Celular/WhatsApp" type='phone' />

                    <input name="END_CEP" placeholder="CEP"
                      onBlur={async (e) => {
                        const cep = e.target.value.replace(/\D/g, '');
                        if (cep.length === 8) {
                          try {
                            const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
                            const data = await res.json();
                            if (!data.erro) {
                              e.target.form.END_RUA.value = data.logradouro || '';
                              e.target.form.END_BAIRRO.value = data.bairro || '';
                              e.target.form.END_CIDADE.value = data.localidade || '';
                              e.target.form.END_ESTADO.value = data.uf || '';
                            }
                          } catch {}
                        }
                      }}
                    />
                    <input name="END_RUA" placeholder="Rua"
                      style={{ textTransform: 'uppercase' }}
                      onBlur={e => e.target.value = e.target.value.toUpperCase()} />
                    <input name="END_NUMERO" placeholder="Número" />
                    <input name="END_COMPLEMENTO" placeholder="Complemento"
                      style={{ textTransform: 'uppercase' }}
                      onBlur={e => e.target.value = e.target.value.toUpperCase()} />
                    <input name="END_BAIRRO" placeholder="Bairro"
                      style={{ textTransform: 'uppercase' }}
                      onBlur={e => e.target.value = e.target.value.toUpperCase()} />
                    <input name="END_CIDADE" placeholder="Cidade"
                      style={{ textTransform: 'uppercase' }}
                      onBlur={e => e.target.value = e.target.value.toUpperCase()} />
                    <select name="END_ESTADO" placeholder="Estado">
                      <option value="AC">AC</option>
                      <option value="AL">AL</option>
                      <option value="AM">AM</option>
                      <option value="AP">AP</option>
                      <option value="BA">BA</option>
                      <option value="CE">CE</option>
                      <option value="DF">DF</option>
                      <option value="ES">ES</option>
                      <option value="GO">GO</option>
                      <option value="MA">MA</option>
                      <option value="MG">MG</option>
                      <option value="MS">MS</option>
                      <option value="MT">MT</option>
                      <option value="PA">PA</option>
                      <option value="PB">PB</option>
                      <option value="PE">PE</option>
                      <option value="PI">PI</option>
                      <option value="PR">PR</option>
                      <option value="RJ">RJ</option>
                      <option value="RN">RN</option>
                      <option value="RO">RO</option>
                      <option value="RR">RR</option>
                      <option value="RS">RS</option>
                      <option value="SC">SC</option>
                      <option value="SE">SE</option>
                      <option value="SP">SP</option>
                      <option value="TO">TO</option>
                    </select>
                    <select name="CLI_TIPO" placeholder="Tipo Cliente">
                      <option value="CONSUMIDOR">Consumidor</option>
                      <option value="REVENDA">Revenda</option>
                    </select>
                    <div style={{ marginBottom: '15px', padding: '10px', border: '1px solid #eee', borderRadius: '8px' }}>
                      <label htmlFor="file-upload" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                        Selecione o arquivo ou tire a foto para este pedido:
                      </label>
                      <input
                        key={inputKey}
                        id="file-upload"
                        type="file"
                        multiple
                        accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        onChange={handleFileChange}
                      />

                      {message && <p style={{ fontSize: '13px', color: '#007bff', marginTop: '5px' }}>{message}</p>}

                      {files.length > 0 && (
                        <div style={{ marginTop: '15px' }}>
                          <p style={{ fontSize: '14px', margin: '5px 0' }}>Arquivos selecionados ({files.length}):</p>
                          {files.map((f, idx) => (
                            <div key={idx} style={{ marginBottom: '8px' }}>
                              {previews[idx] ? (
                                <img
                                  src={previews[idx]}
                                  alt={`Preview ${idx}`}
                                  style={{ width: '100%', maxHeight: '150px', objectFit: 'contain', borderRadius: '8px' }}
                                />
                              ) : (
                                <p style={{ fontSize: '14px', color: '#555' }}>📄 {f.name}</p>
                              )}
                            </div>
                          ))}
                        </div>
                      )}

                    </div> 
                    {/*<div className='btnEnviarArquivo'>
                      <button type="submit" className="cadastrarCliente" disabled={!!etapa}>Salvar</button>
                      <button type="button" onClick={limparArquivos}>Limpar Arquivos</button>
                    </div>*/}
                  </div>

                  <div className='botoesCliente'>
                    <button className="btnCancelar" type="button" onClick={closeModals}>Fechar</button>
                    <button type="submit" className="cadastrarCliente">Salvar</button>
                  </div>

                  {etapa && (
                    <div className="overlay-status">
                      {etapa === 'salvando' && (<><div className="spinner" /><p>Salvando cliente...</p></>)}

                      {etapa === 'cadastrado' && (
                        <>
                          <svg className="check" viewBox="0 0 52 52">
                            <circle className="check-circle" cx="26" cy="26" r="24" fill="none" />
                            <path className="check-mark" fill="none" d="M14 27l8 8 16-16" />
                          </svg>
                          <p>Cliente cadastrado!</p>
                        </>
                      )}

                      {etapa === 'enviando' && (<><div className="spinner" /><p>{message || 'Enviando arquivos...'}</p></>)}

                      {etapa === 'concluido' && (
                        <>
                          <svg className="check" viewBox="0 0 52 52">
                            <circle className="check-circle" cx="26" cy="26" r="24" fill="none" />
                            <path className="check-mark" fill="none" d="M14 27l8 8 16-16" />
                          </svg>
                          <p>Tudo pronto!</p>
                        </>
                      )}

                      {etapa === 'erro' && <p>❌ Erro ao salvar cliente. Tente novamente.</p>}
                    </div>
                  )}

                </form>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Cliente;